import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import 'firebase/compat/firestore';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signInWithEmailAndPassword,
  isSignInWithEmailLink,
  signOut,
  updatePassword,
  sendPasswordResetEmail,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
};

let firebaseApp;

export const ensureFirebaseInitialized = () => {
  if (firebaseApp === undefined) {
    firebaseApp = initializeApp(firebaseConfig);
    firebase.initializeApp(firebaseConfig);
    if (window.browser) {
      window.browser.storage.sync.set({ firebaseConfig: JSON.stringify(firebaseConfig) });
    }
  }
};

export const getFirebase = () => {
  ensureFirebaseInitialized();
  return firebaseApp;
};

export const getFirebaseAuth = () => getAuth(getFirebase());

export const sendSignInLink = (email) =>
  sendSignInLinkToEmail(getFirebaseAuth(), email, {
    url: `${process.env.VUE_APP_ROOT_URL}/setPassword`,
    handleCodeInApp: true,
  });

export const isSignInLink = (link) => isSignInWithEmailLink(getFirebaseAuth(), link);
export const signInWithLink = (email, emailLink) => signInWithEmailLink(getFirebaseAuth(), email, emailLink);
export const login = (email, password) => signInWithEmailAndPassword(getFirebaseAuth(), email, password);
export const logout = () => signOut(getFirebaseAuth());
export const updatePass = (user, password) => updatePassword(user, password);
export const sendPasswordReset = (email) => sendPasswordResetEmail(getFirebaseAuth(), email, {
  url: `${process.env.VUE_APP_ROOT_URL}/login`,
  handleCodeInApp: true,
});
